module.exports = __webpack_public_path__ + "img/android8.21f7c4ae.jpg";